module.exports = __webpack_public_path__ + "static/img/pdf.aabe6b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/pdf.png
// module id = 157
// module chunks = 0